export default {
    data() {
        return {
            SERVICE_CATEGORY_BRUNCH: {
                value: "brunch",
            },
            SERVICE_CATEGORY_MIDI: {
                value: "midi",
            },
            SERVICE_CATEGORY_SOIR: {
                value: "soir",
            },
            SERVICE_CATEGORY_AUTRE: {
                value: "autre",
            },
        };
    },
    methods: {
        getDefaultServiceCategoryLabel(value) {
            if (!value) {
                return "";
            }

            const found = this.ALL_DEFAULT_SERVICE_CATEGORIES_WITH_OTHER.find((w) => w && w.value == value);
            if (typeof found === "undefined") {
                return "";
            }

            const key = `labels.booking.services.categories.${value}`;
            const translated = this.$t(key);

            return translated === key ? "" : translated;
        },
        getDefaultServiceNamePlaceholder(value) {
            const placeholders = {
                [this.SERVICE_CATEGORY_MIDI.value]: "labels.booking.services.namePlaceholders.midi",
                [this.SERVICE_CATEGORY_SOIR.value]: "labels.booking.services.namePlaceholders.soir",
                [this.SERVICE_CATEGORY_BRUNCH.value]: "labels.booking.services.namePlaceholders.brunch",
            };
            const key = placeholders[value] || "labels.booking.services.namePlaceholders.default";

            return this.$tl(key);
        },
    },
    computed: {
        ALL_DEFAULT_SERVICE_CATEGORIES() {
            return [this.SERVICE_CATEGORY_BRUNCH, this.SERVICE_CATEGORY_MIDI, this.SERVICE_CATEGORY_SOIR].filter(
                (category) => category && category.value
            );
        },
        ALL_DEFAULT_SERVICE_CATEGORIES_WITH_OTHER() {
            return [this.SERVICE_CATEGORY_BRUNCH, this.SERVICE_CATEGORY_MIDI, this.SERVICE_CATEGORY_SOIR, this.SERVICE_CATEGORY_AUTRE].filter(
                (category) => category && category.value
            );
        },
    },
};
